import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'cd-footer',
  imports: [RouterLink],
  templateUrl: './cd-footer.html',
  styleUrl: './cd-footer.scss',
})
export class CdFooter {}
